export default __webpack_public_path__ + "static/media/8.9112f1b7.jpg";